function pad2(n) {
  return String(n).padStart(2, '0');
}

function pad3(n) {
  return String(n).padStart(3, '0');
}

export function formatSrtTimestamp(seconds) {
  const totalMs = Math.max(0, Math.round(Number(seconds || 0) * 1000));
  const hours = Math.floor(totalMs / 3600000);
  const minutes = Math.floor((totalMs % 3600000) / 60000);
  const secs = Math.floor((totalMs % 60000) / 1000);
  const ms = totalMs % 1000;
  return `${pad2(hours)}:${pad2(minutes)}:${pad2(secs)},${pad3(ms)}`;
}

function isSectionLine(line) {
  return /^\s*\[[^\]]+\]\s*$/.test(line || '');
}

function normalizeCaptionText(line) {
  return String(line || '').trim().replace(/\s+/g, ' ');
}

function buildTimedLines(lyrics = '', timedLyrics = []) {
  const wordsByLine = new Map();
  (timedLyrics || []).forEach((word) => {
    if (!word || word.lineIndex == null) return;
    const start = Number(word.start);
    const end = Number(word.end);
    if (!Number.isFinite(start)) return;
    const lineIndex = Number(word.lineIndex);
    if (!wordsByLine.has(lineIndex)) wordsByLine.set(lineIndex, []);
    wordsByLine.get(lineIndex).push({
      ...word,
      start,
      end: Number.isFinite(end) ? Math.max(start, end) : start,
      wordIndex: Number(word.wordIndex || 0),
    });
  });

  const lines = String(lyrics || '').split('\n');
  return lines
    .map((line, lineIndex) => {
      const text = normalizeCaptionText(line);
      if (!text || isSectionLine(line)) return null;
      const words = (wordsByLine.get(lineIndex) || []).sort((a, b) => {
        if (a.wordIndex !== b.wordIndex) return a.wordIndex - b.wordIndex;
        return a.start - b.start;
      });
      if (!words.length) return null;
      return {
        lineIndex,
        text,
        start: words[0].start,
        end: words.reduce((max, w) => Math.max(max, w.end), words[0].end),
      };
    })
    .filter(Boolean)
    .sort((a, b) => a.start - b.start || a.lineIndex - b.lineIndex);
}

export function buildSrtCaptions({ lyrics = '', timedLyrics = [], minDurationSec = 0.75 } = {}) {
  const timedLines = buildTimedLines(lyrics, timedLyrics);
  const cues = timedLines.map((line, index) => {
    const nextStart = timedLines[index + 1]?.start;
    let end = Math.max(line.end, line.start + minDurationSec);
    if (Number.isFinite(nextStart) && end >= nextStart) {
      end = Math.max(line.start + 0.001, nextStart - 0.001);
    }
    return { ...line, end };
  }).filter((cue) => cue.end > cue.start);

  return cues.map((cue, index) => [
    String(index + 1),
    `${formatSrtTimestamp(cue.start)} --> ${formatSrtTimestamp(cue.end)}`,
    cue.text,
  ].join('\n')).join('\n\n');
}

export function exportSrt({ title, lyrics, timedLyrics }) {
  const content = buildSrtCaptions({ lyrics, timedLyrics });
  const blob = new Blob([content], { type: 'text/plain;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `${(title || 'captions').replace(/\s+/g, '-').toLowerCase()}.srt`;
  a.click();
  URL.revokeObjectURL(url);
}
